export const aInput = "w-full rounded-lg border border-tark-line bg-tark-bg px-3.5 py-2.5 text-sm text-tark-ink placeholder:text-tark-dim focus:border-tark-cyan/60 focus:outline-none";
export const aLabel = "mb-1.5 block font-mono text-[10px] uppercase tracking-[0.2em] text-tark-dim";

export const AField = ({ label, children }) => (
  <div>
    <label className={aLabel}>{label}</label>
    {children}
  </div>
);

export const StatusPill = ({ status }) => {
  const colors = {
    new: "border-tark-cyan/50 text-tark-cyan",
    contacted: "border-yellow-500/50 text-yellow-400",
    qualified: "border-emerald-500/50 text-emerald-400",
    proposal: "border-tark-blue/60 text-tark-vivid",
    won: "border-emerald-500/60 text-emerald-300",
    lost: "border-red-500/50 text-red-400",
    screening: "border-yellow-500/50 text-yellow-400",
    interview: "border-tark-blue/60 text-tark-vivid",
    offer: "border-emerald-500/50 text-emerald-400",
    hired: "border-emerald-500/60 text-emerald-300",
    rejected: "border-red-500/50 text-red-400",
    open: "border-emerald-500/50 text-emerald-400",
    paused: "border-yellow-500/50 text-yellow-400",
    closed: "border-red-500/50 text-red-400",
  };
  return (
    <span className={`rounded-full border px-2.5 py-1 font-mono text-[10px] uppercase tracking-wider ${colors[status] || "border-tark-line text-tark-mut"}`}>
      {status}
    </span>
  );
};

export const AButton = ({ children, onClick, type = "button", variant = "primary", testId, disabled }) => {
  const styles = {
    primary: "bg-tark-blue text-white hover:bg-tark-vivid",
    ghost: "border border-tark-line text-tark-mut hover:border-tark-cyan/50 hover:text-tark-ink",
    danger: "border border-red-500/40 text-red-400 hover:bg-red-500/10",
  };
  return (
    <button type={type} onClick={onClick} disabled={disabled} data-testid={testId}
            className={`rounded-lg px-4 py-2 font-display text-xs font-bold uppercase tracking-wider transition-colors disabled:opacity-50 ${styles[variant]}`}>
      {children}
    </button>
  );
};
